import Hammer from 'hammerjs';

class MelCarousel extends HTMLElement {
  constructor(self) {
    self = super(self);

    this._children = this.querySelectorAll("li");
    this._numChildren = this._children.length;
    this._currentSlide = 0;
    this._sensitivity = 25;
    this._timer;
    this._sliderManager = new Hammer.Manager(this);
    this._sliderManager.add(new Hammer.Pan({ threshold: 0, pointers: 0 }));

    return self;
  }

  static get classnames() {
    return {
      notAnimating: "is-not-animating",
      nav: "c-carousel__nav",
      navCurrent: "c-carousel__nav-current",
      navTotal: "c-carousel__nav-total"
    }
  }

  static get is() {
    return 'mel-carousel';
  }

  connectedCallback() {
    this.style.width = (this._numChildren / 2) * 100 + "%";

    for (let i = 0; i < this._numChildren; i++) {
      this._children[i].style.width = 100 / this._numChildren + "%";
      this._children[i].style.left = 100 / this._numChildren * i + "%";
    }

    this._setupNav();
    this._addEventListeners();
  }

  _addEventListeners() {
    this._sliderManager.on("pan", e => {
      const percentage = 100 / this._numChildren * e.deltaX / window.innerWidth;
      const percentageCalculated =
        percentage - 100 / this._numChildren * this._currentSlide;

      this.style.transform =
        "translate3d( " + percentageCalculated + "%, 0, 0 )";

      if (e.isFinal) {
        if (e.velocityX > 1) {
          this._goTo(this._currentSlide - 1);
        } else if (e.velocityX < -1) {
          this._goTo(this._currentSlide + 1);
        } else {
          if (percentage <= -(this.sensitivity / this._numChildren)) {
            this._goTo(this._currentSlide + 1);
          } else if (percentage >= this.sensitivity / this._numChildren) {
            this._goTo(this._currentSlide - 1);
          } else {
            this._goTo(this._currentSlide);
          }
        }
      }
    });
    this._sliderManager.on("panstart", e => {
      this.classList.add(MelCarousel.classnames.notAnimating);
    });
    this._sliderManager.on("panend", e => {
      this.classList.remove(MelCarousel.classnames.notAnimating);
    });
    this._nextButton.addEventListener('click', () => {
      this._goTo(this._currentSlide + 1);
    });
    this._prevButton.addEventListener('click', () => {
      this._goTo(this._currentSlide - 1);
    });
  }

  _setupNav() {
    this._nav = document.createElement("ol");
    this._current = document.createElement("li");
    this._total = document.createElement("li");
    this._next = document.createElement("li");
    this._nextButton = document.createElement("button");
    this._nextButton.classList.add('c-carousel__next');
    this._nextButton.innerHTML = '<i class="icon-arrow" data-grunticon-embed aria-hidden="true"></i><i class="icon-arrow-outline" data-grunticon-embed aria-hidden="true"></i>';
    this._prev = document.createElement("li");
    this._prevButton = document.createElement("button");
    this._prevButton.classList.add('c-carousel__prev');
    this._prevButton.innerHTML = '<i class="icon-arrow" data-grunticon-embed aria-hidden="true"></i><i class="icon-arrow-outline" data-grunticon-embed aria-hidden="true"></i>';
    this._next.appendChild(this._nextButton);
    this._prev.appendChild(this._prevButton);
    this._nav.classList.add(MelCarousel.classnames.nav);
    this._current.innerHTML = this._currentSlide + 1;
    this._current.classList.add(MelCarousel.classnames.navCurrent);
    this._total.innerHTML = this._numChildren;
    this._total.classList.add(MelCarousel.classnames.navTotal);
    this._nav.appendChild(this._prev);
    this._nav.appendChild(this._current);
    this._nav.appendChild(this._total);
    this._nav.appendChild(this._next);
    this.parentNode.insertBefore(this._nav, this.nextSibling);
  }

  _goTo(slide) {
    if (slide < 0) {
      this._currentSlide = 0;
    } else if (slide > this._numChildren - 1) {
      this._currentSlide = this._numChildren - 1;
    } else {
      this._currentSlide = slide;
    }

    const percentage = -(100 / this._numChildren) * this._currentSlide;
    this.style.transform = "translateX( " + percentage + "% )";
    this._updateNav();
  }

  _updateNav() {
    this._current.innerHTML = this._currentSlide + 1;

    if (this._currentSlide === 0) {
      this._prevButton.disabled = true;
    } else {
      this._prevButton.disabled = false;
    }

    if (this._currentSlide === this._numChildren - 1) {
      this._nextButton.disabled = true;
    } else {
      this._nextButton.disabled = false;
    }
  }

}

customElements.define(MelCarousel.is, MelCarousel);